import { combineReducers } from '@reduxjs/toolkit'
import orderReducer from './maternityCenterOrderSlice'
import dispatcherReducer from './dispatcherSlice'
import dispatchPageReducer from './dispatchPageSlice'
import customerReducer from './customerSlice'
import serviceNotificationReducer from './serviceNotificationSlice'

// 合并 order 模块下的所有 reducer
const orderStore = combineReducers({
  order: orderReducer,
  dispatcher: dispatcherReducer,
  dispatchPage: dispatchPageReducer,
  customer: customerReducer,
  serviceNotification: serviceNotificationReducer
})

export default orderStore
